var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact us",
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3204,
    transform: "translate(-519 -1070)",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone 1",
    clipPath: "url(#clip1_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0757 12.3489C11.1038 11.3208 11.1038 9.64807 10.0757 8.61999L6.46006 5.00434C5.90699 4.45122 5.14029 4.17096 4.3573 4.23542C3.58926 4.29864 2.89457 4.69016 2.45143 5.3095C2.35943 5.43805 2.27061 5.56848 2.18359 5.69997L9.45408 12.9705L10.0757 12.3489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.9955 23.5394L21.3798 19.9237C20.3519 18.8958 18.679 18.8956 17.6509 19.9237L17.0293 20.5454L24.3001 27.8161C24.4316 27.7291 24.5618 27.6399 24.6903 27.548C25.3096 27.1049 25.7011 26.4102 25.7644 25.6421C25.8289 24.859 25.5486 24.0926 24.9955 23.5394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.5435 21.939C13.8391 21.939 13.1771 21.6648 12.679 21.1668L8.83292 17.3207C8.33494 16.8227 8.0606 16.1605 8.0606 15.4562C8.0606 15.0561 8.14937 14.6698 8.31707 14.3193L1.2857 7.28784C0.296635 9.36458 -0.14106 11.6913 0.0395256 14.0267C0.282865 17.1738 1.64001 20.1301 3.86107 22.3511L7.64869 26.1386C9.86962 28.3596 12.826 29.7168 15.973 29.9602C16.3169 29.9868 16.6605 30 17.0033 30C18.9882 30 20.9409 29.5575 22.7118 28.7141L15.6804 21.6826C15.3299 21.8503 14.9435 21.939 14.5435 21.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6951 0C17.2097 0 16.8162 0.393516 16.8162 0.878906C16.8162 1.3643 17.2097 1.75781 17.6951 1.75781C23.5106 1.75781 28.2419 6.48914 28.2419 12.3047C28.2419 12.7901 28.6355 13.1836 29.1208 13.1836C29.6062 13.1836 29.9998 12.7901 29.9998 12.3047C29.9998 5.51988 24.4799 0 17.6951 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.695 12.3039C17.695 12.3039 17.6951 12.3042 17.6951 12.3047C17.6951 12.7901 18.0886 13.1836 18.574 13.1836C19.0594 13.1836 19.4529 12.7901 19.4529 12.3047C19.4529 11.3354 18.6643 10.5469 17.6951 10.5469C17.2097 10.5469 16.8162 10.94 16.8162 11.4254C16.8162 11.9108 17.2096 12.3039 17.695 12.3039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.6951 8.78906C19.6336 8.78906 21.2107 10.3662 21.2107 12.3047C21.2107 12.7901 21.6042 13.1836 22.0896 13.1836C22.575 13.1836 22.9685 12.7901 22.9685 12.3047C22.9685 9.39691 20.6028 7.03125 17.6951 7.03125C17.2097 7.03125 16.8162 7.42477 16.8162 7.91016C16.8162 8.39555 17.2097 8.78906 17.6951 8.78906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.6951 3.51562C17.2097 3.51562 16.8162 3.90914 16.8162 4.39453C16.8162 4.87992 17.2097 5.27344 17.6951 5.27344C21.5721 5.27344 24.7263 8.42766 24.7263 12.3047C24.7263 12.7901 25.1198 13.1836 25.6052 13.1836C26.0906 13.1836 26.4841 12.7901 26.4841 12.3047C26.4841 7.4584 22.5414 3.51562 17.6951 3.51562Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 131.5,
    y1: -913.5,
    x2: 720,
    y2: 3204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120A01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3204,
    fill: "white",
    transform: "translate(-519 -1070)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone1.fae6bbf146329079a1adcd0df20c69fc.svg";
export { ForwardRef as ReactComponent };